import React from 'react';
import CardComponent from './card';
import { GridSkeleton } from './Skeleton';

const ProductGrid = ({ products, loading }) => {
  if (loading) return <GridSkeleton />;

  if (!products || products.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-gray-300 py-16 text-center text-gray-500">
        <p className="text-lg font-medium">No products found</p>
        <p className="text-sm">Try adjusting your filters or search term.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      {products.map((product) => (
        <CardComponent key={product.id} product={product} />
      ))}
    </div>
  );
};

export default ProductGrid;
